import './Navbar.css'

export const Navbar = () => {
    return <div className='Navbar'>
        <span className='header'>VT BUDDY FINDER</span>
    </div>
}